// frontend/src/components/Chat/Chat.jsx

import React from "react";

import "./Chat.css";

import ChatRooms from "./UI/ChatRooms";
import ChatRoom from "./UI/ChatRoom";

import useMatrix from "./hooks/useMatrix";
import useMatrixRooms from "./hooks/useMatrixRooms";

export default function Chat() {
  const {
    client,
    loading,
    error,
  } = useMatrix();

  const {
    rooms,
    selectedRoomId,
    setSelectedRoomId,
  } = useMatrixRooms(client);

  if (loading) {
    return (
      <section className="chat">

        <div className="chat-room__empty">

          <div className="chat-room__empty-icon">
            ⏳
          </div>

          <h2>
            Подключение к Matrix...
          </h2>

          <p>
            Входим как @manager
          </p>

        </div>

      </section>
    );
  }

  if (error) {
    return (
      <section className="chat">

        <div className="chat-room__empty">

          <div className="chat-room__empty-icon">
            ⚠️
          </div>

          <h2>
            Ошибка Matrix
          </h2>

          <p>
            {error}
          </p>

        </div>

      </section>
    );
  }

  return (
    <section className="chat">

      <aside className="chat__sidebar">

        <ChatRooms
          rooms={rooms}
          selectedRoomId={
            selectedRoomId
          }
          onSelectRoom={
            setSelectedRoomId
          }
        />

      </aside>

      <main className="chat__main">

        <ChatRoom
          roomId={selectedRoomId}
          client={client}
        />

      </main>

    </section>
  );
}